class CircleAnimation {
  constructor() {
    this.circles = document.querySelectorAll('.lc-highlights-card__circle');
    if(this.circles) {
      this.animatedCircles = new Set();
      this.init();
    }
  }

  init() {
    this.circles.forEach(circle => {
      circle.style.opacity = '0';
      circle.style.position = 'absolute';
      circle.style.transition = 'right 0.5s ease-out';
    });

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    this.circles.forEach(circle => {
      if (!this.animatedCircles.has(circle) && this.isElementAlmostInViewport(circle)) {
        circle.classList.add('animate');
        circle.style.opacity = '1';
        this.animatedCircles.add(circle);
      }
    });


    if (this.animatedCircles.size === this.circles.length) {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  isElementAlmostInViewport(el) {
    const rect = el.getBoundingClientRect();
    const buffer = window.innerHeight * 0.3;
    return rect.top < window.innerHeight - buffer && rect.bottom >= 0;
  }
}

export default CircleAnimation;
